import React from "react";

const InstantDeliveryModal = ({ setShowInfoModal }) => {
    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <p style={{ color: "#555", lineHeight: "1.5", borderRadius: "8px", border: "1px solid #f5c6cb", backgroundColor: "#f8d7da", padding: "10px" }}>
                    ⚠️ Sorry! Instant Delivery is currently not available in your area.
                    <br />
                    {/* You can still place your order by choosing <strong>Scheduled Delivery</strong>.
          Select your preferred delivery date to continue. */}
                </p>

            </div>
        </div>
    );
};

export default InstantDeliveryModal;
